module.exports = __webpack_public_path__ + "img/side-icon-53-off.9f755822.svg";